export const NATIVE_LANGUAGE_CODES = ['en', 'ua', 'ru', 'pl', 'be'] as const;

export type NativeLanguageCode = (typeof NATIVE_LANGUAGE_CODES)[number];

export type StudentPublicProfile = {
  displayName: string;
  bio: string | null;
  goals: string | null;
  introVideoUrl: string | null;
  avatarUrl: string | null;
  timezone: string | null;
  nativeLanguages: string[];
  isActive: boolean;
  updatedAt?: string;
};

export type StudentMe = {
  id: number;
  userId: number;
  sku: string;
  slug: string;
  publicPath: string;
  status: string;
  isActive: boolean;
  profile: StudentPublicProfile | null;
  categoryIds: number[];
  createdAt: string;
  updatedAt: string;
};

export type UpdateStudentMeRequest = {
  slug?: string;
  profile?: {
    displayName?: string;
    bio?: string | null;
    goals?: string | null;
    introVideoUrl?: string | null;
    avatarUrl?: string | null;
    timezone?: string | null;
    nativeLanguages?: string[];
  };
  categoryIds?: number[];
};

export type StudentProfileFormValues = {
  displayName: string;
  bio: string;
  goals: string;
  introVideoUrl: string;
  avatarUrl: string;
  timezone: string;
  nativeLanguages: string[];
  categoryIds: string[];
};
